import Flex from 'common/components/Flex'
import Skeleton from 'common/components/Skeleton'
import theme from 'common/theme'
import styled from 'styled-components'

const Content = styled.div`
  width: 300px;
  max-height: 300px;
  overflow: hidden;
  margin: auto;
  padding: 20px 10px 10px;
`

const ShowAll = styled.div`
  border-top: 1px solid ${theme.colors.whiteTwo};
  display: block;
  width: 100%;
  text-align: -webkit-center;
  margin: 20px 0 0 0;
`

function NotificationSkeleton(): JSX.Element {
  return (
    <div data-testid="notification-skeleton">
      <Content>
        <Flex flexDirection="column" justifyContent="space-between">
          <div>
            {[0, 1, 2, 3].map((currentValue) => {
              return (
                <Flex key={currentValue} margin="1px 0 0">
                  <Skeleton
                    width="50px"
                    height="50px"
                    borderRadius="3.3px"
                  />
                  <Flex
                    flexDirection="column"
                    flexGrow="1"
                    margin="0 0 0 10px"
                    padding="0 19px 0 0"
                  >
                    <Skeleton
                      height="25px"
                      marginBottom="6px"
                      borderRadius="4px"
                    />
                    <Skeleton
                      height="10px"
                      marginBottom="3px"
                      borderRadius="4px"
                    />
                    <Skeleton
                      height="10px"
                      marginBottom="6px"
                      borderRadius="4px"
                    />
                    <Skeleton
                      width="82px"
                      height="10px"
                      marginBottom="9px"
                    />
                  </Flex>
                </Flex>
              )
            })}
          </div>
          <Flex justifyContent="center">
            <Skeleton width="300px" height="40px" />
          </Flex>
        </Flex>
      </Content>
      <ShowAll>
        <Skeleton
          width="126px"
          height="14px"
          borderRadius="4px"
          marginBottom="20px"
          marginTop="10px"
        />
      </ShowAll>
    </div>
  )
}

export default NotificationSkeleton
